import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateReportDto } from '../../dtos/create-report.dto';
import { UpdateReportDto } from '../../dtos/update-report.dto';
import { createReportSchema } from '../schemas/create-report.schema';
import { updateReportSchema } from '../schemas/update-report.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
	record: CreateReportDto | UpdateReportDto,

	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Check if record is provided
	if (!record) throw new Error('record is required.');

	let validationResult: ValidationResult | undefined;

	// Determine if it's an update or create operation by checking for 'id'
	if ('id' in record && record.id) {
		// Validate against updateReportSchema if 'id' is present
		validationResult = updateReportSchema().validate(record, {
			abortEarly,
		});
	} else {
		// Validate against createReportSchema if 'id' is not present
		validationResult = createReportSchema().validate(record, {
			abortEarly,
		});
	}

	// Check for validation errors
	if (validationResult?.error) {
		return {
			isValid: false,
			errors: validationResult.error.details?.map((e) => e.message),
		};
	}

	// Return valid result if no errors
	return { isValid: true };
};
